module.exports = __webpack_public_path__ + "img/alert-icon.a6d182fb.svg";